import BaseObject from '../../../../base/base_object';
import {SYSTEM_EVENTS} from '../../../../events/events';
import _ from '../../../../utils/underscore';
import Device from '../../../../utils/device/device';
import Event from '../../../../utils/event';
import {LOGIN_TYPE} from '../../../oauth/oauth_const';


class Rating extends BaseObject {

    static CLASS = 'Rating';
    _hybridService = null;
    _onGameCloseListener = null;
    _isFeatureEnable = false;
    _displayPopUpRatingAfterGame=true;
    _displayPopUpRatingAfterLogin=true;

    init(params) {
        super.init();
        if (_.isNullOrUndefined(params)) {
            return;
        }
        if (Device.os.isIOS) {
            params = params.ios;
        } else if (Device.os.isAndroid) {
            params = params.android;
        }

        if (params.enable) {
            this._isFeatureEnable = true;

        }
    }

    initFeatures(hybridSrv) {
        this._hybridService = hybridSrv;
        if (this._isFeatureEnable) {
            this._subscribe();
        }
        return this;
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onAuthChanged, this);

        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
            this._displayPopUpRatingAfterGame = this._getServiceFactory().regulationService().getRegulation().displayPopUpRatingAfterGame();
            this._displayPopUpRatingAfterLogin = this._getServiceFactory().regulationService().getRegulation().displayPopUpRatingAfterLogin();
        });
    }

    _getServiceFactory() {
        return this._hybridService.serviceFactory;
    }

    async _onAuthChanged() {

        if(!this._getServiceFactory().oAuth2Service().isAuthorized()) {
            this._removeGameCloseListener();
        }

        if (this._checkLoginCondition()) {
            const gamePlayedCondition = await this._checkGamePlayedCondition();
            if(gamePlayedCondition) {
                this._triggerRatingPopup(this._displayPopUpRatingAfterLogin);
            }
        }
    }

    _removeGameCloseListener() {
        this._onGameCloseListener && this._onGameCloseListener.off();
        this._onGameCloseListener = null;
    }

    _onGameClose() {
        this._triggerRatingPopup(this._displayPopUpRatingAfterGame);
    }

    _checkLoginCondition() {
        const isNewLoggedIn =
            this._getServiceFactory().oAuth2Service().isAuthorized() &&
            this._getServiceFactory().oAuth2Service().getLoginType().toString() === LOGIN_TYPE.NEW_LOGIN.toString();

        const isLoginFromRegistration =
            this._getServiceFactory().oAuth2Service().isLoginFromRegistration();

        return isNewLoggedIn && !isLoginFromRegistration;
    }

    _checkGamePlayedCondition() {
        return this._getServiceFactory().recentlyPlayedService().getRecentlyPlayedList()
            .then(games => {
                const isGamePlayed =  _.isArray(games) && games.length >= 1;
                if(isGamePlayed) {
                    return true;
                } else {
                    this._removeGameCloseListener();
                    this._onGameCloseListener = Event.on(SYSTEM_EVENTS.CLOSE_GAME, this._onGameClose, this);
                    return false;
                }
            })
            .catch((err) => {
                this._removeGameCloseListener();
                this._onGameCloseListener = Event.on(SYSTEM_EVENTS.CLOSE_GAME, this._onGameClose, this);
                this.logger.error(`getRecentlyPlayedList() error`, err);
                return false;
            });
    }

    _triggerRatingPopup(bSend) {

        if(bSend) {
            this._hybridService.displayRatingPopup();
            this.logger.info('Rating PopUp Triggered');
        }
    }
}

export default Rating;
